import { Link } from "@tanstack/react-router";
import { Camera, MessageCircle, ArrowRight } from "lucide-react";
import { contactInfo } from "../lib/data";

/** Laagdrempelig offerteblok: foto's via WhatsApp of het formulier. */
export function QuickQuote({ onderwerp }: { onderwerp?: string }) {
  const tekst = encodeURIComponent(
    `Hoi Fedor, ik wil graag een inschatting${onderwerp ? ` voor ${onderwerp}` : ""}. Ik stuur een paar foto's mee.`,
  );
  return (
    <section className="rounded-2xl border border-primary/30 bg-primary/5 p-6 sm:p-8">
      <div className="flex items-center gap-2">
        <Camera className="h-5 w-5 text-primary" aria-hidden="true" />
        <h2 className="font-heading text-xl font-bold tracking-tight text-foreground">
          Wil je direct weten wat dit voor jouw woning kost?
        </h2>
      </div>
      <p className="mt-3 text-sm leading-relaxed text-muted-foreground">
        Stuur 2 of 3 foto's of een schets via WhatsApp. Je krijgt meestal dezelfde dag een eerste
        inschatting — vrijblijvend.
      </p>
      <div className="mt-5 flex flex-col gap-3 sm:flex-row">
        <a
          href={`${contactInfo.whatsappHref}?text=${tekst}`}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex min-h-12 items-center justify-center gap-2 rounded-md bg-primary px-6 py-3 text-sm font-semibold text-primary-foreground transition-colors hover:bg-primary/90"
        >
          <MessageCircle className="h-4 w-4" aria-hidden="true" />
          Foto's sturen via WhatsApp
        </a>
        <Link
          to="/contact"
          className="inline-flex min-h-12 items-center justify-center gap-2 rounded-md border border-input bg-background px-6 py-3 text-sm font-semibold text-foreground transition-colors hover:bg-accent"
        >
          Offerte in 1 minuut aanvragen
          <ArrowRight className="h-4 w-4" aria-hidden="true" />
        </Link>
      </div>
    </section>
  );
}
